"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.belowMeshXxxlBreakpoint = exports.belowMeshXxlBreakpoint = exports.belowMeshXlBreakpoint = exports.belowMeshLgBreakpoint = exports.belowMeshMdBreakpoint = exports.belowMeshSmBreakpoint = exports.belowMeshXsBreakpoint = exports.meshXxxlBreakpoint = exports.meshXxlBreakpoint = exports.meshXlBreakpoint = exports.meshLgBreakpoint = exports.meshMdBreakpoint = exports.meshSmBreakpoint = exports.meshXsBreakpoint = void 0;
exports.meshXsBreakpoint = "@media(min-width: 0)";
exports.meshSmBreakpoint = "@media(min-width: 480px)";
exports.meshMdBreakpoint = "@media(min-width: 640px)";
exports.meshLgBreakpoint = "@media(min-width: 800px)";
exports.meshXlBreakpoint = "@media(min-width: 960px)";
exports.meshXxlBreakpoint = "@media(min-width: 1200px)";
exports.meshXxxlBreakpoint = "@media(min-width: 1600px)";
exports.belowMeshXsBreakpoint = "@media(max-width: 0)";
exports.belowMeshSmBreakpoint = "@media(max-width: 480px)";
exports.belowMeshMdBreakpoint = "@media(max-width: 640px)";
exports.belowMeshLgBreakpoint = "@media(max-width: 800px)";
exports.belowMeshXlBreakpoint = "@media(max-width: 960px)";
exports.belowMeshXxlBreakpoint = "@media(max-width: 1200px)";
exports.belowMeshXxxlBreakpoint = "@media(max-width: 1600px)";